module.exports = __webpack_public_path__ + "img/vertical_6_3_8019.7357bb33.png";